import find from 'lodash.find';

import { METRO_CARD_NUMBER_PARSING_RULES } from '../constants/metro-card-parsing-rules.constants';
import { IMetroCardNumber, IMetroCardLengthList } from '../models/metro-card.model';

export namespace MetroCardUtil {
  const metroCardNumberSectionList = METRO_CARD_NUMBER_PARSING_RULES;
  const metroCardMinLengthList = metroCardNumberSectionList.map(({ minLength }) => minLength) as IMetroCardLengthList;
  const metroCardMaxLengthList = metroCardNumberSectionList.map(({ maxLength }) => maxLength) as IMetroCardLengthList;

  const minMetroCardLength = calculateCommonLength(metroCardMinLengthList);
  const maxMetroCardLength = calculateCommonLength(metroCardMaxLengthList);

  const storeSectionConfig = find(metroCardNumberSectionList, { name: 'store' });
  const customerSectionConfig = find(metroCardNumberSectionList, { name: 'customer' });
  const cardholderSectionConfig = find(metroCardNumberSectionList, { name: 'cardholder' });
  const serviceSectionConfig = find(metroCardNumberSectionList, { name: 'service' });

  export function parseMetroCardNumber(cardNumber: string): IMetroCardNumber {
    const cardNumberLength = cardNumber.length;

    const isShorterThanMetroCardNumber = cardNumberLength < minMetroCardLength;
    const isLongerThanMetroCardNumber = cardNumberLength > maxMetroCardLength;
    if (isShorterThanMetroCardNumber) {
      return splitByLengthList(cardNumber, metroCardMinLengthList);
    } else if (isLongerThanMetroCardNumber) {
      return splitByLengthList(cardNumber.slice(0, maxMetroCardLength), metroCardMaxLengthList);
    }

    return parseValidMetroCardNumber(cardNumber);
  }

  function parseValidMetroCardNumber(cardNumber: string): IMetroCardNumber {
    const storeNumberLength = cardNumber.startsWith('0') ? storeSectionConfig.maxLength : storeSectionConfig.minLength;
    const cardholderNumberLength = cardholderSectionConfig.maxLength;
    const serviceNumberLength = serviceSectionConfig.maxLength;

    const stableSectionsLength = storeNumberLength + cardholderNumberLength + serviceNumberLength;
    const floatSectionLength = cardNumber.length - stableSectionsLength;
    const isValidFloatSectionLength = floatSectionLength <= customerSectionConfig.maxLength;
    const customerNumberLength = isValidFloatSectionLength ? floatSectionLength : customerSectionConfig.maxLength;

    return splitByLengthList(cardNumber, [
      storeNumberLength,
      customerNumberLength,
      cardholderNumberLength,
      serviceNumberLength,
    ]);
  }

  function splitByLengthList(metroCardNumber: string, lengthList: IMetroCardLengthList): IMetroCardNumber {
    let lastSlicePoint;
    const slicePointList = lengthList.map((sectionLength, index) => {
      const slicePoint = {
        start: lastSlicePoint ? lastSlicePoint.end : 0,
        end: calculateCommonLength(lengthList.slice(0, index + 1)),
      };

      lastSlicePoint = slicePoint;

      return slicePoint;
    });

    return slicePointList.map(({ start, end }) => metroCardNumber.slice(start, end)) as IMetroCardNumber;
  }

  function calculateCommonLength(lengthList: number[]) {
    return lengthList.reduce((a: number, b: number) => a + b, 0);
  }
}
